import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wysiwyg-btns"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "wysiwyg-btns wysiwyg-btns-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.editor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            title: "Bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editor.chain().focus().toggleBold().run())),
            disabled: !_ctx.editor.can().chain().focus().toggleBold().run(),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('bold') })
          }, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("b", null, "B", -1)
          ]))], 10, _hoisted_2),
          _createElementVNode("button", {
            title: "Italic",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run())),
            disabled: !_ctx.editor.can().chain().focus().toggleItalic().run(),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('italic') })
          }, [...(_cache[19] || (_cache[19] = [
            _createElementVNode("i", null, "I", -1)
          ]))], 10, _hoisted_3),
          _createElementVNode("button", {
            title: "Underline",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editor.chain().focus().toggleUnderline().run())),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('underline') })
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("span", { style: {"text-decoration":"underline"} }, "U", -1)
          ]))], 2),
          _createElementVNode("button", {
            title: "Line-Through",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editor.chain().focus().toggleStrike().run())),
            disabled: !_ctx.editor.can().chain().focus().toggleStrike().run(),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('strike') })
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("span", { style: {"text-decoration":"line-through"} }, "T", -1)
          ]))], 10, _hoisted_4),
          _createElementVNode("button", {
            title: "Highlight Yellow",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editor.chain().focus().toggleHighlight({ color: '#ffff00' }).run())),
            disabled: !_ctx.editor.can().chain().focus().toggleHighlight({ color: '#ffc078' }).run(),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('highlight', { color: '#ffff00' }) })
          }, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("span", { style: {"background":"#ffff00"} }, "Yellow", -1)
          ]))], 10, _hoisted_5),
          (!_ctx.$props.hideH3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                title: "Title",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editor.chain().focus().toggleHeading({ level: 3 }).run())),
                class: _normalizeClass({ 'is-active': _ctx.editor.isActive('heading', { level: 3 }) })
              }, " T ", 2))
            : _createCommentVNode("", true),
          (!_ctx.$props.hideH4)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                title: "Subtitle",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editor.chain().focus().toggleHeading({ level: 4 }).run())),
                class: _normalizeClass({ 'is-active': _ctx.editor.isActive('heading', { level: 4 }) })
              }, " S ", 2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            title: "Disc List",
            style: {"padding-top":"4px","padding-bottom":"0px"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleBulletList('disc'))),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('bulletList', {class: null}) })
          }, [...(_cache[23] || (_cache[23] = [
            _createElementVNode("svg", {
              "clip-rule": "evenodd",
              "fill-rule": "evenodd",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "2",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "m3.3 15.4c.717 0 1.3.583 1.3 1.3s-.583 1.3-1.3 1.3-1.3-.583-1.3-1.3.583-1.3 1.3-1.3zm2.7 1.85c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75zm-2.7-6.55c.717 0 1.3.583 1.3 1.3s-.583 1.3-1.3 1.3-1.3-.583-1.3-1.3.583-1.3 1.3-1.3zm2.7 1.3c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75zm-2.7-6c.717 0 1.3.583 1.3 1.3s-.583 1.3-1.3 1.3-1.3-.583-1.3-1.3.583-1.3 1.3-1.3zm2.7.75c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75z",
                "fill-rule": "nonzero"
              })
            ], -1)
          ]))], 2),
          _createElementVNode("button", {
            title: "Square List",
            style: {"padding-top":"4px","padding-bottom":"0px"},
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleBulletList('square'))),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('bulletList', {class: 'tiptap-sq-ul'}) })
          }, [...(_cache[24] || (_cache[24] = [
            _createElementVNode("svg", {
              "clip-rule": "evenodd",
              "fill-rule": "evenodd",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "2",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15z",
                "fill-rule": "nonzero"
              })
            ], -1)
          ]))], 2),
          _createElementVNode("button", {
            title: "Ordered List",
            style: {"padding-top":"4px","padding-bottom":"0px"},
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editor.chain().focus().toggleOrderedList().run())),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('orderedList') })
          }, [...(_cache[25] || (_cache[25] = [
            _createElementVNode("svg", {
              "clip-rule": "evenodd",
              "fill-rule": "evenodd",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "2",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "m22 17.75c0-.414-.336-.75-.75-.75h-14.5c-.414 0-.75.336-.75.75s.336.75.75.75h14.5c.414 0 .75-.336.75-.75zm-18.953-1.494c-.621 0-.578.751-.06.751.108.003.371-.076.52.079.218.228.07.693-.293.693-.258 0-.349-.202-.456-.488-.123-.355-.758-.26-.758.203 0 .34.416 1.006 1.21 1.006.187 0 .358-.03.514-.09.474-.181.765-.619.765-1.054 0-.29-.129-.58-.418-.794.671-.726.046-1.562-.815-1.562-.75 0-1.162.49-1.162.864 0 .306.254.404.376.404.395 0 .329-.283.494-.482.104-.13.501-.124.501.174 0 .358-.518.306-.418.296zm18.953-2.506c0-.414-.336-.75-.75-.75h-14.5c-.414 0-.75.336-.75.75s.336.75.75.75h14.5c.414 0 .75-.336.75-.75zm-18.785-1.032c.214-.21.511-.426.8-.686.805-.713.535-2.002-.77-2.002-.813 0-1.24.596-1.24 1.028 0 .478.513.548.708.308.176-.212.152-.595.519-.595.346 0 .517.373.097.792-.065.065-1.065.825-1.258 1.246-.043.096-.071.19-.071.283 0 .159.127.438.494.438h1.597c.344 0 .434-.256.434-.404 0-.314-.284-.408-.497-.408zm18.785-2.968c0-.414-.336-.75-.75-.75h-14.5c-.414 0-.75.336-.75.75s.336.75.75.75h14.5c.414 0 .75-.336.75-.75zm-19.04-1.738c0 .226.113.497.439.497.015 0 .443.032.443-.58v-2.45c0-.335-.206-.479-.401-.479-.224 0-.272.108-.414.306-.183.254-.369.387-.631.511-.23.108-.396.181-.396.428 0 .208.173.388.378.388.18 0 .434-.169.582-.271zm19.04-2.262c0-.414-.336-.75-.75-.75h-14.5c-.414 0-.75.336-.75.75s.336.75.75.75h14.5c.414 0 .75-.336.75-.75z",
                "fill-rule": "nonzero"
              })
            ], -1)
          ]))], 2),
          (!_ctx.$props.hideTable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                title: "Table",
                style: {"padding-top":"4px","padding-bottom":"0px"},
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.insertTable())),
                class: _normalizeClass({ 'is-active': _ctx.editor.isActive('table') })
              }, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("svg", {
                  "clip-rule": "evenodd",
                  "fill-rule": "evenodd",
                  "stroke-linejoin": "round",
                  "stroke-miterlimit": "2",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-12.5 15.5h-4v-4h4zm1.5-4h4v4h-4zm9.5 0v4h-4v-4zm-15-5.5h4v4h-4zm5.5 0h4v4h-4zm5.5 0h4v4h-4zm-11-5.5h4v4h-4zm5.5 0h4v4h-4zm5.5 0h4v4h-4z",
                    "fill-rule": "nonzero"
                  })
                ], -1)
              ]))], 2))
            : _createCommentVNode("", true),
          (_ctx.$props.showAlign)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                title: "Left Align",
                style: {"padding-top":"4px","padding-bottom":"0px"},
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editor.chain().focus().setTextAlign('left').run())),
                class: _normalizeClass({ 'is-active': _ctx.editor.isActive({ textAlign: 'left' }) })
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("svg", {
                  "clip-rule": "evenodd",
                  "fill-rule": "evenodd",
                  "stroke-linejoin": "round",
                  "stroke-miterlimit": "2",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "m17 17.75c0-.414-.336-.75-.75-.75h-13.5c-.414 0-.75.336-.75.75s.336.75.75.75h13.5c.414 0 .75-.336.75-.75zm5-4c0-.414-.336-.75-.75-.75h-18.5c-.414 0-.75.336-.75.75s.336.75.75.75h18.5c.414 0 .75-.336.75-.75zm-9-4c0-.414-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75h9.5c.414 0 .75-.336.75-.75zm7-4c0-.414-.336-.75-.75-.75h-16.5c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75z",
                    "fill-rule": "nonzero"
                  })
                ], -1)
              ]))], 2))
            : _createCommentVNode("", true),
          (_ctx.$props.showAlign)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                title: "Center Align",
                style: {"padding-top":"4px","padding-bottom":"0px"},
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editor.chain().focus().setTextAlign('center').run())),
                class: _normalizeClass({ 'is-active': _ctx.editor.isActive({ textAlign: 'center' }) })
              }, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("svg", {
                  "clip-rule": "evenodd",
                  "fill-rule": "evenodd",
                  "stroke-linejoin": "round",
                  "stroke-miterlimit": "2",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "m6 17.75c0-.414.336-.75.75-.75h10.5c.414 0 .75.336.75.75s-.336.75-.75.75h-10.5c-.414 0-.75-.336-.75-.75zm-4-4c0-.414.336-.75.75-.75h18.5c.414 0 .75.336.75.75s-.336.75-.75.75h-18.5c-.414 0-.75-.336-.75-.75zm0-4c0-.414.336-.75.75-.75h18.5c.414 0 .75.336.75.75s-.336.75-.75.75h-18.5c-.414 0-.75-.336-.75-.75zm4-4c0-.414.336-.75.75-.75h10.5c.414 0 .75.336.75.75s-.336.75-.75.75h-10.5c-.414 0-.75-.336-.75-.75z",
                    "fill-rule": "nonzero"
                  })
                ], -1)
              ]))], 2))
            : _createCommentVNode("", true),
          (_ctx.$props.showAlign)
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                title: "Right Align",
                style: {"padding-top":"4px","padding-bottom":"0px"},
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.editor.chain().focus().setTextAlign('right').run())),
                class: _normalizeClass({ 'is-active': _ctx.editor.isActive({ textAlign: 'right' }) })
              }, [...(_cache[29] || (_cache[29] = [
                _createElementVNode("svg", {
                  "clip-rule": "evenodd",
                  "fill-rule": "evenodd",
                  "stroke-linejoin": "round",
                  "stroke-miterlimit": "2",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "m7 17.75c0-.414.336-.75.75-.75h13.5c.414 0 .75.336.75.75s-.336.75-.75.75h-13.5c-.414 0-.75-.336-.75-.75zm-5-4c0-.414.336-.75.75-.75h18.5c.414 0 .75.336.75.75s-.336.75-.75.75h-18.5c-.414 0-.75-.336-.75-.75zm9-4c0-.414.336-.75.75-.75h9.5c.414 0 .75.336.75.75s-.336.75-.75.75h-9.5c-.414 0-.75-.336-.75-.75zm-7-4c0-.414.336-.75.75-.75h16.5c.414 0 .75.336.75.75s-.336.75-.75.75h-16.5c-.414 0-.75-.336-.75-.75z",
                    "fill-rule": "nonzero"
                  })
                ], -1)
              ]))], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.editor && _ctx.editor.isActive('table') && !_ctx.$props.hideTable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editor.commands.addRowAfter()))
          }, [...(_cache[30] || (_cache[30] = [
            _createElementVNode("b", null, "Add Row", -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editor.commands.addColumnAfter()))
          }, [...(_cache[31] || (_cache[31] = [
            _createElementVNode("b", null, "Add Column", -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.editor.commands.deleteRow()))
          }, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("b", null, "Delete Row", -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editor.commands.deleteColumn()))
          }, [...(_cache[33] || (_cache[33] = [
            _createElementVNode("b", null, "Delete Column", -1)
          ]))])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}